module.exports = __webpack_public_path__ + "img/mail.b5a8d8d5.svg";